import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1300VertragsbeginnStatus: 'idle',
    startProcess1300VertragsbeginnError: undefined as any,
    loadUserParamsProcess1300VertragsbeginnStatus: 'idle',
    loadUserParamsProcess1300VertragsbeginnError: undefined as any,
    stammIni_VertragsmanagementNeuvermAbrEditierbarStatus: 'idle',
    stammIni_VertragsmanagementNeuvermAbrEditierbarError: undefined as any,

    process1300VertragsbeginnList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    stammIni_VertragsmanagementNeuvermAbrEditierbar: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1300Vertragsbeginn = createAsyncThunk('process1300VertragsbeginnSlice/startProcess1300Vertragsbeginn', async ({ process1300Vertragsbeginn }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1300Vertragsbeginn/`,
        prepareData(process1300Vertragsbeginn),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1300VertragsbeginnStatus } = getState().process1300VertragsbeginnSlice
        return startProcess1300VertragsbeginnStatus !== 'pending'
    }
})

export const loadUserParamsProcess1300Vertragsbeginn = createAsyncThunk('process1300VertragsbeginnSlice/loadUserParamsProcess1300Vertragsbeginn', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1300Vertragsbeginn/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1300VertragsbeginnStatus } = getState().process1300VertragsbeginnSlice
        return loadUserParamsProcess1300VertragsbeginnStatus !== 'pending'
    }
})

export const stammIni_VertragsmanagementNeuvermAbrEditierbar = createAsyncThunk('process1300VertragsbeginnSlice/stammIni_VertragsmanagementNeuvermAbrEditierbar', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementNeuvermAbrEditierbar/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_VertragsmanagementNeuvermAbrEditierbarStatus } = getState().process1300VertragsbeginnSlice
        return stammIni_VertragsmanagementNeuvermAbrEditierbarStatus !== 'pending'
    }
})

const Process1300VertragsbeginnSlice = createSlice({
    name: 'process1300VertragsbeginnSlice',
    initialState,
    reducers: {
        resetstartProcess1300Vertragsbeginn: (state) => {
            state.job = undefined
            state.startProcess1300VertragsbeginnError = undefined
        },
        resetstartProcess1300VertragsbeginnError: (state) => {
            state.startProcess1300VertragsbeginnError = undefined
        },
        resetloadUserParamsProcess1300Vertragsbeginn: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1300VertragsbeginnError = undefined
        },
        resetloadUserParamsProcess1300VertragsbeginnError: (state) => {
            state.loadUserParamsProcess1300VertragsbeginnError = undefined
        },
        resetstammIni_VertragsmanagementNeuvermAbrEditierbar: (state) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbar = undefined
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = undefined
        },
        resetstammIni_VertragsmanagementNeuvermAbrEditierbarError: (state) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = undefined
        },
        removeFromProcess1300VertragsbeginnListById: (state, action) => {
            state.process1300VertragsbeginnList = state.process1300VertragsbeginnList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1300VertragsbeginnListByIds: (state, action) => {
            state.process1300VertragsbeginnList = state.process1300VertragsbeginnList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1300VertragsbeginnList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1300VertragsbeginnStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1300VertragsbeginnList = []
            state.startProcess1300VertragsbeginnStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1300Vertragsbeginn.pending, (state) => {
            state.startProcess1300VertragsbeginnStatus = 'pending'
            state.startProcess1300VertragsbeginnError = undefined
        })
        builder.addCase(startProcess1300Vertragsbeginn.fulfilled, (state, action) => {
            state.startProcess1300VertragsbeginnStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1300Vertragsbeginn.rejected, (state, action) => {
            state.startProcess1300VertragsbeginnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1300VertragsbeginnError = action.error.message
            } else {
                state.startProcess1300VertragsbeginnError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1300Vertragsbeginn.pending, (state) => {
            state.loadUserParamsProcess1300VertragsbeginnStatus = 'pending'
            state.loadUserParamsProcess1300VertragsbeginnError = undefined
        })
        builder.addCase(loadUserParamsProcess1300Vertragsbeginn.fulfilled, (state, action) => {
            state.loadUserParamsProcess1300VertragsbeginnStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1300Vertragsbeginn.rejected, (state, action) => {
            state.loadUserParamsProcess1300VertragsbeginnStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1300VertragsbeginnError = action.error.message
            } else {
                state.loadUserParamsProcess1300VertragsbeginnError = action.payload
            }
        })

        builder.addCase(stammIni_VertragsmanagementNeuvermAbrEditierbar.pending, (state) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarStatus = 'pending'
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = undefined
        })
        builder.addCase(stammIni_VertragsmanagementNeuvermAbrEditierbar.fulfilled, (state, action) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarStatus = 'idle'

            {
                state.stammIni_VertragsmanagementNeuvermAbrEditierbar = action.payload

            }
        })
        builder.addCase(stammIni_VertragsmanagementNeuvermAbrEditierbar.rejected, (state, action) => {
            state.stammIni_VertragsmanagementNeuvermAbrEditierbarStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = action.error.message
            } else {
                state.stammIni_VertragsmanagementNeuvermAbrEditierbarError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1300Vertragsbeginn,
    resetstartProcess1300VertragsbeginnError,
    resetloadUserParamsProcess1300Vertragsbeginn,
    resetloadUserParamsProcess1300VertragsbeginnError,
    resetstammIni_VertragsmanagementNeuvermAbrEditierbar,
    resetstammIni_VertragsmanagementNeuvermAbrEditierbarError,
    removeFromProcess1300VertragsbeginnListById,
    removeFromProcess1300VertragsbeginnListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1300VertragsbeginnSlice.actions
export default Process1300VertragsbeginnSlice.reducer
